const { windowLoaded } = require('@grpn/document-states');
const {
  dynamicallyLoadRecaptcha,
  toCamel,
  setErroneousness,
  checkValidEmail,
  goToRequiredNotice,
} = require('../helpers/report_helpers');

windowLoaded.then(() => {
  document
    .querySelector('select[name="complaint"]')
    .addEventListener('change', complaintWatcher);
  document.querySelectorAll('input[name="owner_or_agent"]').forEach(el => {
    el.addEventListener('change', authorizedAgentWatcher);
  });
  document
    .querySelectorAll("input[name='trademark_copyright_patent']")
    .forEach(el => {
      el.addEventListener('change', radioValueChanged);
    });
  document
    .querySelector('#application-tbl input')
    .addEventListener('keyup', registrationRowWatcher);
  document
    .querySelector('#application-tbl select')
    .addEventListener('change', registrationRowWatcher);
  translateCountryKeys();
  setCustomerReportsLinks();
  dynamicallyLoadRecaptcha();
});

function hide(selector) {
  document.querySelector(selector).classList.add('hide');
}

function show(selector) {
  document.querySelector(selector).classList.remove('hide');
}

const addressValidationInfo = {
  australia: {
    zipCode: '^\\d{4}$',
    states: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'],
  },
  belgium: {
    zipCode: '^\\d{4}$',
    states: null,
  },
  canada: {
    zipCode: '^[ABCEGHJKLMNPRSTVXY]{1}\\d{1}[A-Z]{1} *\\d{1}[A-Z]{1}\\d{1}$',
    states: [
      'AB',
      'BC',
      'MB',
      'NB',
      'NL',
      'NT',
      'NS',
      'NU',
      'ON',
      'PE',
      'QC',
      'SK',
      'YT',
    ],
  },
  france: {
    zipCode: '^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$',
    states: null,
  },
  germany: {
    zipCode: '^(?!01000|99999)(0[1-9]\\d{3}|[1-9]\\d{4})$',
    states: null,
  },
  ireland: {
    zipCode: '^[AC-FHKNPRTV-Y]{1}[0-9]{1}[0-9W]{1}[ -]?[0-9AC-FHKNPRTV-Y]{4}$',
    states: null,
  },
  italy: {
    zipCode: '^[0-9]{5}$',
    states: [
      'AG',
      'AL',
      'AN',
      'AO',
      'AP',
      'AQ',
      'AR',
      'AT',
      'AV',
      'AB',
      'BG',
      'BI',
      'BL',
      'BN',
      'BO',
      'BR',
      'BS',
      'BT',
      'BZ',
      'CA',
      'CB',
      'CE',
      'CH',
      'CI',
      'CL',
      'CN',
      'CO',
      'CR',
      'CS',
      'CT',
      'CZ',
      'EN',
      'FC',
      'FE',
      'FG',
      'FI',
      'FM',
      'FR',
      'GE',
      'GO',
      'GR',
      'IM',
      'IS',
      'KR',
      'LC',
      'LE',
      'LI',
      'LO',
      'LT',
      'LU',
      'MB',
      'MC',
      'ME',
      'MI',
      'MN',
      'MO',
      'MS',
      'MT',
      'NA',
      'NO',
      'NU',
      'OG',
      'OR',
      'OT',
      'PA',
      'PC',
      'PD',
      'PE',
      'PG',
      'PI',
      'PN',
      'PO',
      'PR',
      'PT',
      'PU',
      'PV',
      'PZ',
      'RA',
      'RC',
      'RE',
      'RG',
      'RI',
      'RM',
      'RN',
      'RO',
      'SA',
      'SI',
      'SO',
      'SP',
      'SR',
      'SS',
      'SV',
      'TA',
      'TE',
      'TN',
      'TO',
      'TP',
      'TR',
      'TS',
      'TV',
      'UD',
      'VA',
      'VB',
      'VC',
      'VE',
      'VI',
      'VR',
      'VS',
      'VT',
      'VV',
    ],
  },
  netherlands: {
    zipCode: '^[1-9][0-9]{3} *(?!SA|SD|SS)[A-Z]{2}$',
    states: null,
  },
  newZealand: {
    zipCode: '^\\d{4}$',
    states: null,
  },
  poland: {
    zipCode: '^\\d{2}-\\d{3}$',
    states: null,
  },
  spain: {
    zipCode: '^\\d{5}$',
    state: null,
  },
  unitedArabEmirates: {
    zipCode: null,
    states: null,
  },
  unitedKingdom: {
    zipCode:
      '^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? ' +
      '{1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$',
    states: null,
  },
  unitedStates: {
    zipCode: '^\\d{5}$|^\\d{5}-\\d{4}$',
    states: [
      'AL',
      'AK',
      'AZ',
      'AR',
      'CA',
      'CO',
      'CT',
      'DC',
      'DE',
      'FL',
      'GA',
      'HI',
      'ID',
      'IL',
      'IN',
      'IA',
      'KS',
      'KY',
      'LA',
      'ME',
      'MD',
      'MA',
      'MI',
      'MN',
      'MS',
      'MO',
      'MT',
      'NE',
      'NV',
      'NH',
      'NJ',
      'NM',
      'NY',
      'NC',
      'ND',
      'OH',
      'OK',
      'OR',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VT',
      'VA',
      'WA',
      'WV',
      'WI',
      'WY',
    ],
  },
};

function getCountry() {
  const select = document.getElementById('country-select');
  return select.options[select.selectedIndex].getAttribute('name');
}

function setCustomerReportsLinks() {
  const el = document.getElementById('customer-reports');
  document.getElementById('c-support').href = el.dataset.cslink;
  document.getElementById('m-support').href = el.dataset.mslink;
}

function translateCountryKeys() {
  const countryKeys = document
    .getElementById('country-select')
    .dataset.countries.split(',');
  countryKeys.pop();
  countryKeys
    .map(country => {
      const key = `js.modules.infringement.countries.${country}`;
      return { key: country, translated: I18n.translate(key) };
    })
    .sort((a, b) => {
      if (a.translated === b.translated) {
        return 0;
      }
      return a.translated < b.translated ? -1 : 1;
    })
    .forEach(({ key, translated }) => {
      const el = document.getElementById('country-select');
      const option = document.createElement('option');
      option.setAttribute('name', key);
      option.setAttribute('value', key);
      option.appendChild(document.createTextNode(translated));
      el.appendChild(option);
    });
}

document.getElementById('country-select').addEventListener('change', () => {
  const country = getCountry();
  hide('#allStreet');
  hide('#allCity');
  hide('#allState');
  hide('#allZipcode');

  if (country) {
    const zip = addressValidationInfo[country].zipCode;
    const { states } = addressValidationInfo[country];
    show('#allStreet');
    show('#allCity');
    if (zip) {
      show('#allZipcode');
    }
    if (states) {
      const nodes = document.querySelectorAll(
        '[name="state"] option:not(:first-child)'
      );

      nodes.forEach(curNode => {
        curNode.parentNode.removeChild(curNode);
      });

      states.forEach(state => {
        const option = document.createElement('option');
        option.setAttribute('name', state);
        option.setAttribute('value', state);
        option.appendChild(document.createTextNode(state));
        document.querySelector('select[name=state]').appendChild(option);
      });
      show('#allState');
    }
  }
});

function complaintWatcher() {
  hide('label[for=complaint_other]');
  const complaintValue = document.querySelector('select[name="complaint"]')
    .value;
  if (complaintValue === 'other') {
    show('label[for=complaint_other]');
    enableSelector('input[name="complaint_other"]');
    showTrademarkDeclaration();
  } else {
    disableSelector('input[name="complaint_other"]');
    if (complaintValue === 'copyright') {
      showCopyrightDeclaration();
    } else {
      showTrademarkDeclaration();
    }
  }
}

function authorizedAgentWatcher() {
  const agent = document.querySelector('input[name="owner_or_agent"]:checked');
  hide('#represented_owner_section');
  hide('#owner_agent_other_section');
  disableSelector('input[name="represented_owner"]');
  disableSelector('input[name="owner_agent_other"]');

  if (agent && agent.value === 'authorized_agent') {
    show('#represented_owner_section');
    enableSelector('input[name="represented_owner"]');
  } else if (agent && agent.value === 'other') {
    show('#owner_agent_other_section');
    enableSelector('input[name="owner_agent_other"]');
  }
}

function enableSelector(selector) {
  show(selector);
  document.querySelector(selector).disabled = false;
}

function disableSelector(selector) {
  hide(selector);
  document.querySelector(selector).value = '';
  document.querySelector(selector).disabled = true;
}

function radioValueChanged() {
  if (this.value === 'no') {
    hide('#application-tbl');
  } else {
    show('#application-tbl');
  }
}

const checkables = [
  'complaint',
  'validEmail',
  'validResponsibleEmail',
  'emailMatch',
  'ownerOrAgent',
  'trademarkCopyrightPatent',
  'street',
  'city',
  'state',
  'zip',
  'zipCode',
  'country',
  'reCaptcha',
  'declare',
  'sign',
];

const entryIds = ['#entry_1', '#entry_2', '#entry_3'];

document
  .querySelector('#report_infringement')
  .addEventListener('submit', event => {
    let passed = true;
    checkables.forEach(checkable => {
      passed = handleFieldRequiredness(checkable) && passed;
    });
    if (!passed) {
      event.preventDefault();
    }
  });

const checkers = {
  city() {
    return document.querySelector('[name=city]').value.length > 0;
  },
  complaint(check) {
    switch (document.querySelector('select[name=complaint]').value) {
      case 'trademark':
      case 'copyright':
      case 'patent':
        return true;
      case 'other':
        check('complaint_other');
        return true;
      default:
        return false;
    }
  },
  complaint_other() {
    return (
      document.querySelector('input[name=complaint_other]').value.length > 0
    );
  },
  country() {
    return document.querySelector('[name=country]').value.length > 0;
  },
  declare() {
    const checked = document.querySelector('input[name=declare]:checked');
    if (!checked) {
      return false;
    }
    return checked.value === 'on';
  },
  emailMatch() {
    const email = document.querySelector('input[name=form_email_address]')
      .value;
    const confirmEmail = document.querySelector('input[name=confirm_email]')
      .value;
    return email === confirmEmail;
  },
  validEmail() {
    const email = document.querySelector('input[name=form_email_address]')
      .value;
    if (email.length > 0) {
      return checkValidEmail(email);
    }
    return true;
  },
  validResponsibleEmail() {
    const responsiblePartyEmail = document.querySelector(
      'input[name=email_responsible_party]'
    ).value;
    if (responsiblePartyEmail.length > 0) {
      return checkValidEmail(responsiblePartyEmail);
    }
    return true;
  },
  ownerOrAgent(check) {
    const checked = document.querySelector(
      'input[name=owner_or_agent]:checked'
    );
    if (!checked) {
      return false;
    }
    const type = checked.value;
    if (type === 'ip_rights_owner') {
      return true;
    }
    if (!type) {
      return false;
    }
    check(`ownerOrAgent_${type}`);
    return true;
  },
  ownerOrAgent_authorized_agent() {
    return (
      document.querySelector('input[name=represented_owner]').value.length > 0
    );
  },
  ownerOrAgent_other() {
    return (
      document.querySelector('input[name=owner_agent_other]').value.length > 0
    );
  },
  urls() {
    return document.querySelector('[name=urls]').value.length > 0;
  },
  reCaptcha() {
    // putting on window object for unit tests
    if (grecaptcha) {
      window.grecaptcha = grecaptcha;
    }
    return window.grecaptcha.getResponse().length > 0;
  },
  sign() {
    const checked = document.querySelector('input[name=sign]:checked');
    if (!checked) {
      return false;
    }
    return checked.value === 'on';
  },
  state() {
    const country = getCountry();
    if (
      !(addressValidationInfo[country] != null
        ? addressValidationInfo[country].states
        : undefined)
    ) {
      return true;
    }
    return document.querySelector('[name=state]').value.length > 0;
  },
  street() {
    return document.querySelector('[name=street]').value.length > 0;
  },
  trademarkCopyrightPatent() {
    if (
      !document.querySelector('input[name=trademark_copyright_patent]:checked')
    ) {
      return false;
    }
    switch (
      document.querySelector('input[name=trademark_copyright_patent]:checked')
        .value
    ) {
      case 'no':
        return true;
      case 'yes':
        const validEntries = [];
        entryIds.forEach(entry => {
          const title = `${entry} .form-title`;
          const number = `${entry} .form-number`;
          const status = `${entry} .form-status`;
          const hasTitle = document.querySelector(title).value.length > 0;
          const hasNumber = document.querySelector(number).value.length > 0;
          const statusVal = document.querySelector(status).value;
          const hasStatus =
            statusVal === 'application' || statusVal === 'registration';
          if (hasTitle || hasNumber || hasStatus) {
            validEntries.push(registrationRowLogic(title, number, status));
          }
        });
        return validEntries.length > 0 && validEntries.indexOf(false) < 0;
      default:
        return false;
    }
  },
  zip() {
    const country = getCountry();
    if (
      (addressValidationInfo[country] != null
        ? addressValidationInfo[country].zipCode
        : undefined) === null
    ) {
      return true;
    }
    return document.querySelector('input[name=zip]').value.length > 0;
  },
  zipCode() {
    const country = getCountry();
    const zipCodePattern =
      addressValidationInfo[country] != null
        ? addressValidationInfo[country].zipCode
        : undefined;
    if (!zipCodePattern || !checkers.zip()) {
      return true;
    }
    const zipCodeExpression = new RegExp(zipCodePattern);
    return (
      null !==
      document
        .querySelector('input[name=zip]')
        .value.trim()
        .match(zipCodeExpression)
    );
  },
};

function handleFieldRequiredness(field) {
  let innerPassing = true;
  const outerPassed = checkers[field](
    innerField => (innerPassing &= handleFieldRequiredness(innerField))
  );
  setErroneousness(!outerPassed, field);
  const passed = innerPassing && outerPassed;
  if (!outerPassed) {
    goToRequiredNotice(field);
  }
  return passed;
}

document.querySelectorAll('.required-input').forEach(input => {
  const checkerKey = toCamel(input.name);
  checkables.push(checkerKey);
  checkers[checkerKey] = () => input.value.length > 0;
});

function showCopyrightDeclaration() {
  show('#copyright_claim');
  hide('#trademark_claim');
}

function showTrademarkDeclaration() {
  show('#trademark_claim');
  hide('#copyright_claim');
}

function registrationRowWatcher() {
  entryIds.forEach(entry => {
    const selector = `${entry} span.checkmark`;
    if (
      registrationRowLogic(
        `${entry} .form-title`,
        `${entry} .form-number`,
        `${entry} .form-status`
      )
    ) {
      show(selector);
    } else {
      hide(selector);
    }
  });
}

function registrationRowLogic(title, number, status) {
  const { value } = document.querySelector(status);
  return (
    document.querySelector(title).value.length > 0 &&
    document.querySelector(number).value.length > 0 &&
    (value === 'application' || value === 'registration')
  );
}
